const ACTION = {
  RESTORE_TOKEN: 'RESTORE_TOKEN',
  REMOVE_TOKEN: 'REMOVE_TOKEN',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
};

export default ACTION;
